const UPLOAD_DELAY_MS = 1200

/** Either part alone is a valid upload: photos without a comment, or the reverse. */
export interface IEntityPhotoPayload {
  files: File[]
  comment: string
}

/**
 * Uploads photos and/or a comment attached to an arbitrary entity, addressed by
 * a numeric type and id. Stub until the endpoint exists: only the body is
 * replaced by the real API call from src/components/modules/API/, the signature
 * stays as is.
 */
export const uploadEntityPhoto = (
  entityType: number,
  entityId: number,
  payload: IEntityPhotoPayload,
): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, UPLOAD_DELAY_MS)
  })
